export default "__VITE_ASSET__B31AJdjy__"